<template>
  <base-spinner :open="isloading"></base-spinner>
  <div class="card-body card-body--padding--2">
  <base-message
  v-if="!isloading"
  :servermessages="servermessages"
  ></base-message>
    <div class="vehicle-form vehicle-form--layout--account">
      <div class="vehicle-form__item vehicle-form__item--select">
        <select
          class="form-control"
          aria-label="Year"
          v-model="selectedyear"
          @change="getMakes"
        >
          <option value="0">Select Year</option>
          <option v-for="year in years" :key="year">
            {{ year.year }}
          </option>
        </select>
      </div>
      <div class="vehicle-form__item vehicle-form__item--select">
        <select
          class="form-control"
          aria-label="Brand"
          v-model="selectedmake"
          @change="getModels"
          :disabled="disableMake"
        >
          <option value="">Select Make</option>
          <option v-for="make in makes" :key="make.make" :value="make.make">
            {{ make.desc }}
          </option>
        </select>
      </div>
      <div class="vehicle-form__item vehicle-form__item--select">
        <select
          class="form-control"
          aria-label="Model"
          v-model="selectedmodel"
          @change="getEngines"
          :disabled="disableModel"
        >
          <option value="">Select Model</option>
          <option
            v-for="model in models"
            :key="model.model"
            :value="model.model"
          >
            {{ model.desc }}
          </option>
        </select>
      </div>
      <div class="vehicle-form__item vehicle-form__item--select">
        <select
          class="form-control"
          aria-label="Engine"
          v-model="selectedengine"
          :disabled="disableEngine"
        >
          <option value="">Select Engine</option>
          <option
            v-for="engine in engines"
            :key="engine.engine"
            :value="engine.engine"
          >
            {{ engine.desc }}
          </option>
        </select>
      </div>
      <div class="vehicle-form__divider">Or</div>
      <div class="row">
        <!-- <div class="span5">
          <div class="flex-container--drilldown-select-vehicle-inputs">
            <input
              type="text"
              class="form-control form-control-order-entry"
              placeholder="Enter License Plate"
              aria-label="License Plate"
            />
          </div>
        </div> -->
        <div class="span5">
          <div class="flex-container--drilldown-select-vehicle-inputs">
            <input
              type="text"
              class="form-control form-control-order-entry"
              placeholder="Enter VIN number"
              aria-label="VIN number"
              v-model="vin"
            />
          </div>
        </div>
        <div class="span2"></div>
      </div>
    </div>
    <div class="garage-add-vehicle-button">
      <button type="button" class="btn btn-sm btn-primary" @click="addVehicle">Add Vehicle</button>
    </div>
  </div>
</template>


<script>
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from "vuex";
import VehicleSearch from '../../../mixins/vehicle_search.js';

export default {
  data() {
    return {
      selectedyear: 0,
      selectedmake: "",
      selectedmodel: "",
      selectedengine: "",
      years: [],
      makes: [],
      models: [],
      engines: [],
      vin: '',
      isloading: false,
      servermessages: []
    };
  },
  mixins: [VehicleSearch],
  emits: ['added-vehicle'],
  methods: {
    addVehicle() {
      this.servermessages = [];

      if (this.vin != '') {
        this.getVINInfo();
      } else {
        if (this.selectedyear === 0 || this.selectedmake === '' || this.selectedmodel === '' || this.selectedengine === '') {
          this.servermessages.push("Please select a valid vehicle to save.");
          return false;
        }
        const catpn = this.$store.getters['storeConfigID'];
        let data = {
                "EHCUST": {"value": this.$store.getters.customer},
                "CATPN": {"value": catpn},
                "QYEAR": {"value": this.selectedyear},
                "QMAKE": {"value": this.selectedmake},
                "QMKDSC": {"value": this.makes.find(make => make.make === this.selectedmake).desc },
                "QMODEL": {"value": this.selectedmodel},
                "QMODSC": {"value": this.models.find(model => model.model === this.selectedmodel).desc },
                "QCARCD": {"value": this.selectedengine},
                "QENDSC": {"value": this.engines.find(engine => engine.engine === this.selectedengine).desc }
        }

        this.addSavedVehicle(data);
      }
    },
    getVINInfo() {
      this.isloading = true;
      const catpn = this.$store.getters['storeConfigID'];
      axiosvl.post(this.$store.getters['api/vin_uri'], {
          "webroutine": {
            "context": {
                "session-key-method": "hidden"
            },
            "fields": {
                "EHCUST": {"value": this.$store.getters.customer},
                "CATPN": {"value": catpn},
                "QVIN": {"value": this.vin},
            }
          }
      })
      .then((response) => {
          const fields = response.data.webroutine.fields
          const messages = [];
          if (fields.RESULTCOD.value === 'OK') {
            let data = {
                    "EHCUST": {"value": this.$store.getters.customer},
                    "CATPN": {"value": catpn},
                    "QYEAR": {"value": fields.QYEAR.value },
                    "QMAKE": {"value": fields.QMAKE.value },
                    "QMKDSC": {"value": fields.QMKDSC.value },
                    "QMODEL": {"value": fields.QMODEL.value},
                    "QMODSC": {"value": fields.QMODSC.value },
                    "QCARCD": {"value": fields.QCARCD.value },
                    "QENDSC": {"value": fields.QENDSC.value }
            }

            this.addSavedVehicle(data);
          } else {
            const wrmessages = response.data.webroutine.messages;

            for (var i = 0; i < wrmessages.length; i++) {
              messages.push(wrmessages[i]);
            }

            // Return code is not "OK" but no messages appear, add a custom error message
            if (messages.length === 0) {
              messages.push("Something went wrong. Please try again later.");
            }
          }

          this.isloading = false;
          this.servermessages = messages;
      })
      .catch((error) => {
        this.isloading = false;
          console.error("error - " + error);
      });
    },
    addSavedVehicle(requestdata) {
      this.isloading = true;

      axiosvl.post(this.$store.getters['api/add_saved_vehicle_uri'], {
          "webroutine": {
            "context": {
                "session-key-method": "hidden"
            },
            "fields": requestdata
          }
      })
      .then((response) => {
          const fields = response.data.webroutine.fields
          const messages = [];

          if (fields.RESULTCOD.value === 'OK') {
            messages.push("Vehicle has been saved successfully.");
            this.$store.dispatch("vehicle/setNewSavedVehicleAdded", true);
            this.$emit("added-vehicle");
          } else {
            const wrmessages = response.data.webroutine.messages;

            for (var i = 0; i < wrmessages.length; i++) {
              messages.push(wrmessages[i]);
            }

            // Return code is not "OK" but no messages appear, add a custom error message
            if (messages.length === 0) {
              messages.push("Something went wrong. Please try again later.");
            }
          }

          this.isloading = false;
          this.servermessages = messages;
      })
      .catch((error) => {
        this.isloading = false;
          console.error("error - " + error);
      });
    }
  },
  computed: {
    disableMake() {
        return this.selectedyear > 0 ? false : true;
    },
    disableModel() {
        return this.selectedmake != '' ? false : true;
    },
    disableEngine() {
        return this.selectedmodel != '' ? false : true;
    },
    ...mapGetters(["userIsAuthenticated"]),
    ...mapGetters("system", ["erppartition", "language"]),
  },
  created() {
    this.selectedyear = 0;
    this.getYears();
  }
};
</script>